import img_del from "../img/delete.svg";
import {fetcher, alter} from './restClient.js';
import {fetchOne, createForm, createAlert, removeSubs, removeAlerts} from "./commonUI.js";

/**
 * fetch and fill #lijst
 * @return {Promise<void>}
 */
const fetch = async (lijst) => {
    try {
        lijst.empty();
        const hoofd = await fetcher(dataUrl);
        console.group('hoofdEntiteiten'); console.log(hoofd); console.groupEnd();
        await Promise.all([...hoofd].map(h => lijst.addFillRow(h)));
    } catch (e) {
        if (e?.cause === 404) lijst.insertAdjacentElement("beforebegin", createAlert('Sorry, I got nothing?', 'info'));
        console.error(dataUrl +' not serving?\n'+e.message); console.trace(e);
    }
    return Promise.resolve();
}
/**
 * Create a Bootstrap image card, /w url in footer
 * @param {String} url='' the src of the img
 * @return {HTMLElement} htmlElement figure
 */
const createBootstrapOverlayImg = (url = img_del) => {
    const fig = document.createDocumentFragment().appendChild(document.createElement('figure'));
    const img = fig.appendChild(document.createElement('img'));
    const overlay = fig.appendChild(document.createElement('figcaption')).appendChild(document.createElement('small'));
    img.id = 'avatar_img';
    img.title = img.alt = 'avatar_img';
    img.src = url;
    img.setSrc = (url = '') => { img.src = overlay.innerHTML = url; }
    img.setTitle = (tit = '') => { img.title = img.alt = tit; }
    img.grow = () => { fig.classList.contains('collapsed') && fig.classList.remove('collapsed'); }
    img.collapse = () => { fig.classList.contains('collapsed') || fig.classList.add('collapsed'); }
    return fig;
}
/**
 * prepare a field for bootstrap validation
 * @param {Element} el - input field that needs validating
 * @param {Object} [options] - options
 * @param {string} [options.tooltip="Duuh!&nbsp;It's&nbsp;obliged!"] - a custom tooltip
 * @param {boolean} [options.required=true] - required attribute set
 * @param {Object.<string,string|number>} [options.attributes={}] - optional attributes to add
 */
const addValidation = (el, {tooltip = 'Duuh! It\'s obliged!', required = true, attributes = {}} = {}) => {
    const tip = el.parentElement.insertAdjacentElement('beforeend', document.createElement('div'));
    tip.classList.add('invalid-tooltip');
    tip.innerHTML = tooltip;
    el.required = required;
    el.setAttribute('data-bs-toggle', 'tooltip');
    if (required) {
        // overkill? PopOver sanitizes, but are we sure and is it like we would desire ;-).
        el.title = new DOMParser().parseFromString(tooltip, "text/html").documentElement.textContent;
    } else {
        el.title = new DOMParser().parseFromString('While not required, I do wonder:\n'+tooltip, "text/html").documentElement.textContent;

    }
    // el?.setCustomValidity(tooltip); // out-of-scope
    Object.entries(attributes).map(([k, v]) => el.setAttribute(k, v));
}
/**
 * maakt een buttonElement voor Form navigation
 * @param dir
 * @param url
 * @return {HTMLButtonElement}
 */
const createNavButton = ({dir = 'next', url = ''} = {}) => {
    const btn = document.createDocumentFragment().appendChild(document.createElement('button'));
    btn.classList.add('btn','btn-outline-dark','btn-floating','btn-sm');
    btn.dataset.location = url;
    btn.appendChild(document.createElement('i')).classList.add('bi', ((dir === 'next')?'bi-journal-arrow-down':'bi-journal-arrow-up'));
    btn.setAttribute('aria-controls', 'detail');
    btn.setAttribute('aria-label', dir);
    btn.dataset.bsToggle ="tooltip";
    btn.title = (dir==='next')?"Onwards":"Treading back a little";
    btn.addEventListener('click', (ev) => document.getElementById('detail').querySelector('form').fill(fetchOne(url), url));
    return btn;
}
/**
 * Voegt previous and next buttons aan het form indien er zijn
 * @param url
 */
const prev_next_Buttons = (url = '') => {
    const lijst = [...document.getElementById('lijst').querySelector(('table ')).tBodies.item(0).children].map(c => c.firstElementChild.dataset.location);
    const regex = new RegExp(url, 'i');
    const idx = lijst.findIndex((el) => regex.test(el));
    if (idx > -1) {
        const formNav = document.querySelector('#detail form').appendChild( document.createElement('div'));
        formNav.id = 'form-nav';
        if (idx > 0) {
            formNav.append(createNavButton({dir:'prev', url: lijst[idx-1]}));
        }
        if (idx < (lijst.length-1)) {
            formNav.append(createNavButton({url: lijst[idx+1]}));
        }
    }
}
/**
 * enhanced html5 form
 * actually - combining bootstrap floating labels and input groups depending on viewport dimensions
 *
 * @return {HTMLFormElement} - a form
 */
export const createDetailForm = () => {
    const form = createForm(); // extended HTMLFormElement class
    form.setAttribute('aria-label','New user'); // role form isn't required here - https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/form_role
    form.setAttribute('action', dataUrl); // take your starting position
    let parent; // added for readability
    let el; // pass through temp HTMLElement
    // Fieldset data - row 1
    parent = form.appendChild(document.createElement('fieldset'));
    parent.appendChild(document.createElement('legend')).innerHTML = 'Persoon';
    // col 1
    // personals
    parent = parent.appendChild(document.createElement('div'));
    form.create_input('id').disabled=true;
    addValidation(form.create_input('name'));
    addValidation(form.create_input('department'), {tooltip: 'No department is identified by a single or no letter?', attributes: {pattern: '.*[\\w]{2}.*'}});
    form.create_input('salutation', {type:'select', options: {'Mr.': 'Mr', 'Ms.': 'Ms'}});
    // col 2a
    parent = parent.insertAdjacentElement('afterend', document.createElement('div')).appendChild(document.createElement('div'));
    // avatar
    el = form.create_input('avatar', {type: 'select', parentNode: parent});
    const img = el.insertAdjacentElement('afterend', createBootstrapOverlayImg()).querySelector('img');
    img.collapse();
    // col 2b
    parent = el.parentElement.insertAdjacentElement('afterend', document.createElement('div'));
    // app_data
    addValidation(form.create_input('total Role Count', {type: 'number', parentNode: parent}), {tooltip: 'No more than one role or zero?\nWhy even bother adding this user?', required:false, attributes: {min: 2}});
    addValidation(form.create_input('internal', {type: 'checkbox', parentNode: parent}), {tooltip: 'So, where is this user\'s desk then?\nPlease use the word &ldquo;external&rdquo; in department if no part of this organization.', required:false, attributes: {'data-related':'department','data-related-pattern':'external'}});
    // Fieldset controls - row 2 (1 col)
    parent = form.appendChild(document.createElement('fieldset'));
    parent.appendChild(document.createElement('legend')).innerHTML = 'Control';
    form.create_button('nieuw',{parentNode: parent}).hidden = true;
    form.create_button('voeg toe',{parentNode: parent});
    form.create_button('update',{parentNode: parent}).hidden = true;
    form.create_button('toon alle',{parentNode: parent, theme: 'btn-outline-secondary'});
    /**
     * populate form
     * @param json keys match names/option values
     * @param url where's the action at
     */
    form.fill = (json, url='') => {
        document.getElementById('form-nav')?.remove();
        [...form.firstChild.elements].map(el=>el.disabled = true);
        form.action = url;
        form.setAttribute('aria-label','Detail selected user');
        let {lastModified, avatar, internal, salutation, ...inputs} = json;
        Object.keys(inputs).map(k=> form.elements.namedItem(k).value = inputs[k]);
        if (internal) form.elements.namedItem('internal').checked = true;
        [...form.elements.namedItem('salutation').childNodes].map(o => {
            if (o.value === salutation)  o.selected = true;
        });
        // img.classList.contains('collapsed') && img.classList.remove('collapsed');
        img.grow();
        if (avatar) {
            const url= new URL('../img/'+avatar, dataUrl);
            // const url = "../../../data/img/"+avatar;
            img.setSrc(url);
            img.setTitle("avatar "+inputs.name);
            [...form.elements.namedItem('avatar').childNodes].map(o => o.selected = (o.value === avatar));
        } else {img.collapse();}
        img.parentElement.previousElementSibling.classList.add('collapsed');
        // fetch('../../data/img/'+avatar.replace(/'\.png'/i,'\.svg')).then(r=>r.text()).then(text => form.querySelector('#avatar_img').innerHTML = text).catch(console.error.bind(console));
        (form.querySelector('fieldset:first-child > legend > span:last-of-type') || form.querySelector('fieldset:first-child > legend').insertAdjacentElement("beforeend", document.createElement('span'))).innerHTML = ' '+inputs.id;
        // cool but subject to changes: form.firstElementChild.firstElementChild.insertAdjacentElement("beforeend", document.createElement('span')).innerHTML = ' '+inputs.id;
        el = form.querySelector('fieldset:first-child > span:last-of-type') || form.querySelector('fieldset:first-child').insertAdjacentElement("beforeend", document.createElement('span'));
        el.innerHTML = (new Date(lastModified)).toLocaleDateString('be-BE', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
        el.dataset.lastModified = (new Date(lastModified)).toLocaleDateString('be-BE', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
        // cool but subject to changes: form.firstElementChild.insertAdjacentElement("beforeend", document.createElement('span')).innerHTML = (new Date(lastModified)).toLocaleDateString('be-BE', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
        form.querySelectorAll('fieldset button[name="nieuw"], fieldset button[name="update"]').forEach(el => el.hidden = false);
        form.querySelector('fieldset button[name="voeg toe"]').hidden = true;
        prev_next_Buttons(url);
    };
    /**
     * reset form
     */
    form.empty = (clear= true) => {
        form.setAttribute('aria-label','New user');
        [...form.firstChild.elements].map(el=>el.disabled = false);
        form.elements.namedItem('id').disabled = true;
        img.parentElement.previousElementSibling.classList.remove('collapsed');
        document.getElementById('form-nav')?.remove();
        if (clear) {
            img.setTitle('avatar_img');
            img.setSrc(img_del);
            img.collapse();
            form.querySelectorAll('legend > span:last-of-type, fieldset > span:last-of-type').forEach(el => el.remove());
            // form.removeAttribute('action');
            form.setAttribute('action', dataUrl);
            form.reset();
        }
    }
    /**
     * gets current values and creates a JSON string for it.
     * @return {string} JSON string
     */
    form.toJson = () => {
        console.log(JSON.stringify(Object.fromEntries(new FormData(form))));
        return JSON.stringify(Object.fromEntries(new FormData(form)));
    }
    return form;
}

/**
 * add controls to form/single overview
 * @param {HTMLFormElement} detail form
 */
export const addFormElementListeners = (detail) => {
    // For your convenience - readability
    const formTabEl = document.querySelector('nav a[data-bs-target="#detail"]');
    const lijst = document.getElementById('lijst').lastElementChild.firstElementChild;
    const formElements = [...detail.elements].filter(el => !(el instanceof HTMLFieldSetElement || el instanceof HTMLButtonElement)); // only those that count!
    const nieuw = detail.querySelector('fieldset:last-of-type button[name="nieuw"]');
    const voegToe = detail.querySelector('fieldset:last-of-type button[name="voeg toe"]');
    const update = detail.querySelector('fieldset:last-of-type button[name="update"]');
    const toonAlle = detail.querySelector('fieldset:last-of-type button[name="toon alle"]');
    // Hook into tab changes
    // clear it if Tab looses focus -> Not the most user-friendly, Maybe, but also, Nothing left to chance!
    formTabEl.addEventListener('hidden.bs.tab', e => {
        removeAlerts();
        removeSubs();
        detail.empty();
        detail.classList.remove('was-validated');
        // Button play added here - could as well be handled within our From object empty method
        nieuw.hidden = update.hidden = true;
        nieuw.classList.contains('btn-outline-primary') || nieuw.classList.add('btn-outline-primary');
        nieuw.classList.remove('btn-outline-secondary');
        voegToe.hidden = false;
        update.innerHTML = 'update';
        // detail.querySelector('#avatar_img').classList.remove('collapsed');
    });
    // Hook into tab changes
    // fill it if Tab gets focus, and none was selected
    formTabEl.addEventListener('show.bs.tab', e => {
        if(!/.*detail.*/i.test(detail.getAttribute('aria-label'))) { // we already have it filled in?
            const location = lijst.querySelector('td:first-of-type')?.getAttribute('data-location');
            if (location) {
                fetchOne(location).catch(e=>console.error(e)); // We don't do nothing, already having an empty form, ready to add a new one
            } else {
                detail.insertAdjacentElement('beforebegin', createAlert('Geen lijst = geen selectie!\nVoeg je er alvast ééntje toe dan?', 'warning'));
            }
        }
    });
    // Just to be safe? -> Obsolete: nop! it's HTML5
    detail.addEventListener('submit', function (e) {
        e.preventDefault(); // prevent normal submit action
        // detail.reportValidity();
        // detail.checkValidity()
        console.count('a submit was clicked!');
        e.stopPropagation();
    });
    // reset validation on input
    formElements.map(el => el.addEventListener('focus', ()=> { formElements.map(el => el.classList.remove('is-invalid', 'is-valid')); el.setCustomValidity(''); bootstrap.Tooltip.getInstance(el)?.enable(); detail.classList.remove('was-validated');}));
    /**
     * Why make this fake step-by-step server-side validation even harder?
     * Now we need no extra params.
     *
     * @return {boolean} - valid or not
     */
    const formValidation = () => {
        let i = 1; // skip the id.
        while (formElements.length > i) {
            bootstrap.Tooltip.getInstance(formElements[i])?.disable();
            if (!formElements[i].validity.valid || (formElements[i].type === 'number' && formElements[i].validity.rangeUnderflow)) {
                formElements[i].classList.add('is-invalid');
                formElements[i].setCustomValidity('wrong');
                break;
            } else if (formElements[i].dataset?.related && !formElements[i].checked)  {
                if (!new RegExp(formElements[i].dataset.relatedPattern).test(detail.elements[formElements[i].dataset.related].value)) {
                    formElements[i].classList.add('is-invalid');
                    formElements[i].setCustomValidity('wrong');
                    break;
                }
            } else {
                formElements[i].classList.add('is-valid'); // up to here we're okay
                formElements[i].setCustomValidity('');
            }
            i++;
        }
        return formElements.length === i;
    }
    // new is pushed
    nieuw.addEventListener('mousedown', (e)=>{
        formTabEl.dispatchEvent(new Event('hidden.bs.tab'));
        e.stopPropagation();
    });
    // add is pushed
    voegToe.addEventListener('mousedown', async (e)=>{
        detail.classList.remove('was-validated'); // never trust ad-hoc coding ;-)
        if (formValidation()){
            let location;
            try {
                location = await alter(detail.action, detail.toJson()).then(location => new URL(location, dataUrl));
                await fetchOne(location);
                nieuw.hidden = false;
                update.hidden = false;
                voegToe.hidden = true;
                removeAlerts();
                formElements[1].dispatchEvent(new Event('focus'));
            } catch (e) {
                console.error(location ?? detail.action + ' not added?\n' + e.message);
                console.trace(e);
                detail.insertAdjacentElement('beforebegin', createAlert('Foutcode: ' + (e.cause ?? "Niet gekend") + '\n' + 'Er ging iets mis aan de serverzijde!'));
            }
        } else {
            detail.classList.add('was-validated');
        }
        e.stopPropagation();
    });
    // update/save is pushed
    update.addEventListener('mousedown', async (e) => {
        detail.classList.remove('was-validated'); // to be sure
        if (e.target.name === 'update') {
            detail.empty(false);
            update.name = update.innerHTML = 'save';
            nieuw.classList.toggle('btn-outline-primary');
            nieuw.classList.toggle('btn-outline-secondary');
            removeSubs();
        } else {
            if (formValidation()) {
                removeAlerts(); // clean the board
                const location = detail.action;
                await alter(location, detail.toJson(), 'PUT')
                    .catch(e => {
                        console.error(location + ' not updating?\n' + e.message);
                        console.trace(e);
                        detail.insertAdjacentElement('beforebegin', createAlert('Foutcode: ' + (e.cause ?? "Niet gekend") + '\n' + 'Er ging iets mis aan de serverzijde!'));
                    })
                    .then(() => fetchOne(location))
                    // chances are error is coming from REST response on update at this point. we already filled this form before ;-)
                    .catch(e => detail.insertAdjacentElement('beforebegin', createAlert('Foutcode: ' + (e.cause ?? "Niet gekend") + '\n' + 'We kunnen deze niet meer terug vinden?')));
                update.name = update.innerHTML = 'update';
                nieuw.classList.toggle('btn-outline-primary');
                nieuw.classList.toggle('btn-outline-secondary');
                formElements[1].dispatchEvent(new Event('focus'));
            } else {
                detail.classList.add('was-validated');
            }
        }
        e.stopPropagation();
    });
    // show all is pushed
    toonAlle.addEventListener('mousedown', async (e) => {
        await fetch(lijst); // already handled!
        bootstrap.Tab.getInstance(document.querySelector('nav a[data-bs-target="#lijst"]')).show();
        e.stopPropagation();
    });
    // avatar selection changed
    detail.querySelector('select[name="avatar"]').addEventListener('change', (e) =>{
        const img = detail.querySelector('#avatar_img');
        const avatar = e.target.value;
        if (avatar) {
            // img.src = "../../data/img/"+avatar;
            const url=new URL('../img/'+avatar, dataUrl);
            if (img.parentElement.classList.contains('collapsed')) {
                img.setSrc(url);
                img.setTitle("avatar "+avatar);
                img.grow(); // img.classList.contains('collapsed') && img.classList.remove('collapsed');
            } else {
                img.collapse(); // img.classList.contains('collapsed') || img.classList.add('collapsed');
                // console.log(img.getAnimations()); // experimental
                img.parentElement.addEventListener('animationend', (e)=>{
                    if (img.parentElement.classList.contains('collapsed')) {
                        // img.src = url;
                        img.setSrc(url);
                        // img.title = img.alt = "avatar "+avatar;
                        img.setTitle("avatar "+avatar);
                    }
                    img.grow();
                    e.stopPropagation();
                }, {once: true});
            }
        } else {
            img.collapse();
            img.setSrc();
            img.setTitle();
        }
    });
    // a span acts as a label
    [...detail.querySelectorAll('span[data-html-for]')].map(s => s.addEventListener('click', (e)=>{
        const input = document.getElementById(e.target.dataset.htmlFor);
        if(input.type === 'text') input.setSelectionRange(0,0);
        input.focus();
    }));
}
/**
 * add a personal touch
 * @param {HTMLFormElement} detail form
 */
export const populateForm = (detail) => {
    const url = new URL('../img', dataUrl);
    fetcher(url)
        .then(options => options?.images.map(o => detail.elements.namedItem('avatar').appendChild(new Option(o.replace(/\.(gif|bmp|png|svg|jpe?g)$/gi, ' ($1)'), o))))
        .catch(e=>console.error(e.message)); // ah well, no pics then
}
